import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=8947392e&scoped=true&"
import script from "./Link.vue?vue&type=script&lang=js&"
export * from "./Link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8947392e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8947392e')) {
      api.createRecord('8947392e', component.options)
    } else {
      api.reload('8947392e', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=8947392e&scoped=true&", function () {
      api.rerender('8947392e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Components/Navigation/Link.vue"
export default component.exports